<template>
  <Footer class="footer">
    <div class="content-panel flex-justify">
      <span v-html="copyright.copr" style="float:left;" />
      <div class="links">
        <span class="link" v-for="(text, key) in copyright.links" :key="key">
          <a role="button" :href="$ComDomain.Modules.about[key]">{{ text }}</a>
          <span>|</span>
        </span>
      </div>
    </div>
  </Footer>
</template>
<script>
import { Footer } from 'iview'
import { copyright } from '../../locale'

export default {
  name: 'layoutFooter',
  data() {
    return {
      copyright
    }
  },
  components: {
    Footer
  }
}

</script>
<style lang="less">
  .mobile {
    .footer {
      .content-panel {
        width: 100%;
      }
    }

  }

</style>
<style scoped lang="less">
div.footer {
  height: 70px;
  line-height: 70px;
  text-align: right;
  color: #fff;
  background: #000;
  padding: 0;

  .link {
    a {
      color: #fff;
    }

    span {
      margin: 10px;
    }

    &:last-child span {
      display: none;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/commons/components/layout/Footer.vue